export enum MapBackground {
	NONE = 'NONE',
	SATELLITE = 'SATELLITE',
	STREET = 'STREET',
	BASIC = 'BASIC'
}